import StatisticsTab from './Statistics';

export * from './Statistics.ui';

export default StatisticsTab;
